<smrts-dialog [title]="title" [hasFootnote]="true">

  <div class="content">
    <p-floatlabel variant="on">
      <input pInputText type="text" [(ngModel)]="nome" style="width: 350px;" />
      <label>Nome Conta</label>
    </p-floatlabel>
  </div>

  <div footnote class="inline-element footnote">
    <button class="accent-text-button btn-cancelar" mat-button [mat-dialog-close]="false">
      Cancelar
    </button>
    <button class="white-text-button" mat-flat-button (click)="salvarClick()">
      Salvar
    </button>
  </div>
</smrts-dialog>